import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { BaseGoogleAnalyticsCategory } from '../../base-google-analytics-category';

enum ImageDialogAction {
  DOWNLOAD_PREVIEW = 'download_preview',
  DOWNLOAD_QUALITY = 'download_quality',
  DOWNLOAD_FROM_DROPBOX = 'download_from_dropbox'
}

export class ImageDialog extends BaseGoogleAnalyticsCategory {
  constructor(ga: GoogleAnalyticsService, isEnabled: boolean) {
    super(ga, 'catalog_image_dialog', isEnabled);
  }

  public downloadPreview(id: string) {
    this.event(ImageDialogAction.DOWNLOAD_PREVIEW, id);
  }

  public downloadQuality(userId: string, id: string, quality: string) {
    if (!userId) {
      userId = 'anonymous';
    }
    this.event(ImageDialogAction.DOWNLOAD_QUALITY, `${userId}_${id}_${quality}`);
  }

  public downloadFromDropbox(id: string) {
    this.event(ImageDialogAction.DOWNLOAD_FROM_DROPBOX, id);
  }
}
